import "./BasketItem.css"
import { FaTrashAlt } from 'react-icons/fa';

const BasketItem = (props) => {

  let currItem = props.basket.find(basketItem => basketItem.ItemID === props.thisItem.ItemID);

  if (!currItem) {
    return null;
  }

  return (
    <div className="itemCont">
      <button className="delete-item-absolute" onClick={() => props.deleteItemFromBasket(props.thisItem.ItemID, 0)}><FaTrashAlt /></button>
      <div className="imgCont">
        <img src={'https://dblla03zmq1su.cloudfront.net/' + props.thisItem.ItemID + '.png'}
          alt={currItem.ItemID}
          loading='lazy'></img>
      </div>
      <div className="item-detail">
        <p>{currItem.Description}</p>
        <p>Nett: R{currItem.BasePrice}</p>
        <span className="quantity-control">
          {<button onClick={() => props.updateQuantity(props.thisItem.ItemID, -1)}>-</button>}{" "}{currItem.Quantity}{" "}{<button onClick={() => props.updateQuantity(props.thisItem.ItemID, 1)}>+</button>}
        </span>
      </div>
    </div>
  )
}

export default BasketItem